import { Component } from '@angular/core';
import { TRAIN_SIGNAL_CLASSES } from '../../services/trein-presentation';

@Component({
  standalone: false,
  selector: 'app-atlas-trein-legend',
  templateUrl: './atlas-trein-legend.component.html',
  styleUrls: ['./atlas-trein-legend.component.scss'],
})
export class AtlasTreinLegendComponent {
  readonly signalClasses = TRAIN_SIGNAL_CLASSES;
}
